'use client';

import { createContext, Dispatch, SetStateAction, useEffect, useState } from 'react';
import { fetchCourseProgress } from '@/data/courseProgress';
import { CourseProgress } from '@/redis/progressStore';

type ProgressContextValue = {
  progress: null | CourseProgress;
  setProgress?: Dispatch<SetStateAction<CourseProgress>>;
};

export const ProgressContext = createContext({
  progress: null,
  setProgress: (_) => {},
} as ProgressContextValue);

export function ProgressProvider({
  children,
  hasAccess,
  userId,
  courseId,
}: {
  children: React.ReactNode;
  hasAccess: boolean;
  userId?: string;
  courseId?: string;
}) {
  const [progress, setProgress] = useState<CourseProgress | null>(null);
  console.log('ProgressProvider', progress);

  useEffect(() => {
    if (userId && courseId && hasAccess && !progress) {
      fetchCourseProgress({
        userId,
        courseId,
      }).then((progress) => {
        setProgress(progress);
      });
    }
  }, [userId, courseId, hasAccess, progress]);

  return (
    <ProgressContext.Provider value={{ progress, setProgress }}>
      {children}
    </ProgressContext.Provider>
  );
}
